module.exports = __webpack_public_path__ + "static/img/hotRdetail.770ab42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hotpic/hotRdetail.jpg
// module id = VfQ/
// module chunks = 52